import { render } from "./Select.vue?vue&type=template&id=75d36f5e"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import exportComponent from "/home/berisalam-console-demo/webapps/berisalam-console-demo/releases/1787064449663/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__